import React from "react";
import LeftParentSidebar from "../../components/Parents/LeftParentSidebar";
import RightParentSidebar from "../../components/Parents/RightParentSidebar";
import ReportesContent from "../../components/ReportesContent";
import { ChakraProvider, Flex , Box} from '@chakra-ui/react';

function DashboardHome() {
    return (
        <ChakraProvider>
            <Flex h="100vh" align="stretch">
                <LeftParentSidebar />
                <Box flex="1"> {/* Esto permite que MainContent ocupe el espacio restante */}
                    <ReportesContent/> 
                </Box>
                <RightParentSidebar />
            </Flex>
        </ChakraProvider>
    );
}

export default DashboardHome;
